export default __webpack_public_path__ + "static/media/blog_page_adds_sidebar.e649473a.png";